"use client";

import Image from "next/image";
import { useRef, useState } from "react";

import styles from "./VideoPlayer.module.scss";

export const VideoPlayer = (props) => {
  const { video, image } = props;

  if (!video) {
    return null;
  }

  const [startedPlaying, setStartedPlaying] = useState(false);

  const videoRef = useRef(null);

  const handleInitalPlay = () => {
    if (!videoRef.current) {
      return;
    }

    videoRef.current.play();

    setStartedPlaying(true);
  };

  return (
    <div className={styles.video__player}>
      <video
        controls={startedPlaying}
        ref={videoRef}
        style={{ width: "100%" }}
        poster={process.env.NEXT_PUBLIC_STRAPI_BACKEND_URL + image.url}
      >
        <source
          src={process.env.NEXT_PUBLIC_STRAPI_BACKEND_URL + video.url}
          type={video.mime}
        />
      </video>

      {!startedPlaying && (
        <button onClick={handleInitalPlay}>
          <Image src="/images/play.svg" alt="play" width={50} height={50} />
        </button>
      )}
    </div>
  );
};
